import { resolveLifecyclePaymentStatus } from "./payment-status";

/** Actual PDF row projection; zero is meaningful, NULL remains absent. */
export function bookingPdfPaymentRow(
  trip: { status: unknown; payment_status: unknown;
    historicalCouponCoverage?: { kind: string; couponAmount: number; paymentDue: number; rentalCashCollected: number } | null },
  t: (key: string, fallback?: any) => string,
): { label: string; value: string } | null {
  // Coupon cover must never mask a recorded refund.
  const code = typeof trip.payment_status === "string" && /^\d+$/.test(trip.payment_status.trim())
    ? Number(trip.payment_status.trim()) : trip.payment_status;
  if (code === 3) {
    return { label: t("trip.payment"), value: resolveLifecyclePaymentStatus({
      tripStatus: trip.status, paymentStatus: trip.payment_status,
    }, t).label };
  }
  if (trip.historicalCouponCoverage?.kind === "fully_coupon_covered"
      && trip.historicalCouponCoverage.couponAmount === 690
      && trip.historicalCouponCoverage.paymentDue === 0
      && trip.historicalCouponCoverage.rentalCashCollected === 0) {
    return { label: t("trip.payment"), value: t("trip.payment_covered_by_coupon", "Covered by coupon") };
  }
  if (trip.payment_status == null || trip.payment_status === "") return null;
  return {
    label: t("trip.payment"),
    value: resolveLifecyclePaymentStatus({
      tripStatus: trip.status, paymentStatus: trip.payment_status,
    }, t).label,
  };
}
